export const INITIAL_AVATAR_COLORS = [
  'bg-lime-500',
  'bg-emerald-500',
  'bg-sky-500',
  'bg-violet-500',
  'bg-amber-500',
  'bg-rose-500',
  'bg-teal-500',
  'bg-indigo-500',
] as const;

export function resolveAvatarColorClass(id: string): string {
  let hash = 0;

  for (let index = 0; index < id.length; index += 1) {
    hash += id.charCodeAt(index);
  }

  return INITIAL_AVATAR_COLORS[hash % INITIAL_AVATAR_COLORS.length];
}

export function resolveInitials(source: {
  firstName?: string | null;
  lastName?: string | null;
  name?: string | null;
  email?: string | null;
}): string {
  const first = source.firstName?.trim()?.charAt(0) ?? '';
  const last = source.lastName?.trim()?.charAt(0) ?? '';
  const fromNameParts = `${first}${last}`.toUpperCase();
  if (fromNameParts) {
    return fromNameParts;
  }

  const name = source.name?.trim();
  if (name) {
    return name.charAt(0).toUpperCase();
  }

  const email = source.email?.trim();
  if (email) {
    return email.charAt(0).toUpperCase();
  }

  return '?';
}
